<template>
  <el-dialog
    class="perfect_information"
    :close-on-click-modal="false"
    :title="title"
    :visible="true"
    :before-close="close"
  >
    <div class="step3">
      <ul class="videoList">
        <li v-for="item in videoList" :key="item.videoId" @click="chooseVideo(item.videoId)">
          <div class="thumb">
            <img :src="item.thumb| imageUrl('',700,400)" alt />
            <span>{{item.duration | secondToDate}}</span>
            <span class="checkedbox" :class="{'checked':checkedVideoId === item.videoId}"></span>
          </div>
          <p>{{item.title}}</p>
          <div class="footer">
            <img :src="peopleMessage.avatar | imageUrl('/static/profile_img_default.png',99,99)" alt />
            <span class="nickName">{{peopleMessage.nickname}}</span>
            <span class="viewCount">
              <i></i>
              {{item.viewCount}}
            </span>
          </div>
        </li>
      </ul>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="videoTotalRecord"
        @current-change="handleCurrentChange"
        :current-page.sync="videoNum"
      ></el-pagination>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{$t('global.取 消')}}</el-button>
      <el-button type="primary" @click="nextStep">{{$t('global.下一步')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "information",
  components: {},
  props: ["closeVisible", "goToStep", "isInternational", "matchId"],
  data() {
    return {
      title: "",
      formLabelWidth: "140px",
      peopleMessage: {},
      videoSize: 15,
      videoNum: 1,
      videoTotalRecord: 0,
      videoList: [],
      checkedVideoId: null
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.title = this.$t('global.选择已发布作品');
      this.peopleMessage = this.$store.state.peopleMessage;
      const {
        userId,
        userType,
        avatar,
        nickname,
        gender,
        birthday,
        field,
        signature,
        weiboLink,
        qqLink,
        homeLink,
        facebookLink,
        twitterLink,
        instagramLink,
        wechatLink,
        ...rest
      } = this.peopleMessage;
      this.getVideos(this.videoNum);
    },
    handleCurrentChange(val) {
      this.getVideos(val);
    },
    nextStep() {
      if (this.checkedVideoId) {
        this.$emit("goToStep", this.checkedVideoId);
      }
    },
    close() {
      this.$emit("closeVisible");
    },
    getVideos(videoNum) {
      const url = `/api/match/video/getVideosByMatchId?matchId=${this.matchId}&pageIndex=${videoNum}&pageSize=${this.videoSize}&userId=${this.peopleMessage.userId}`;
      this.$http.get(url).then(res => {
        this.checkedVideoId = null;
        this.videoList = res.data.list;
        this.videoTotalRecord = res.data.totalRecord;
      });
    },
    chooseVideo(videoId) {
      this.checkedVideoId = videoId;
    }
  },
};
</script>
<style lang="css">
.perfect_information .el-dialog {
  width: 1160px;
  font-size: 16px;
}
.perfect_information .el-dialog .el-dialog__header .el-dialog__title {
  font-size: 24px;
  font-weight: 600;
}
.perfect_information .step3 .el-pagination {
  text-align: right;
  padding-top: 20px;
}
.perfect_information .el-dialog .step3 .el-pagination button {
  background: #fff;
}
.perfect_information .el-dialog .step3 ul.videoList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 0 20px;
  border-bottom: 2px solid #eaebec;
}
.perfect_information .el-dialog .step3 ul.videoList li {
  width: 350px;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  cursor: pointer;
  margin-right: 12px;
}
.perfect_information .el-dialog .step3 ul.videoList li:nth-child(3n) {
  margin-right: 0;
}
.perfect_information .el-dialog .step3 ul.videoList li .thumb {
  position: relative;
  width: 100%;
}
.perfect_information .el-dialog .step3 ul li .thumb img {
  width: 100%;
  height: 200px;
  border-radius: 10px;
  border: 1px solid #eaebec;
}
.perfect_information .el-dialog .step3 ul li .thumb span {
  position: absolute;
  bottom: 10px;
  right: 20px;
  background: rgba(0, 0, 0, 0.7);
  font-size: 14px;
  color: #fff;
  padding: 3px 5px;
  border-radius: 3px;
}
.perfect_information .el-dialog .step3 ul li p {
  margin: 5px 0;
  font-size: 18px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  height: 50px;
}
.perfect_information .el-dialog .step3 ul li .footer {
  display: flex;
  flex-direction: row;
}
.perfect_information .el-dialog .step3 .footer img {
  width: 34px;
  height: 34px;
  border-radius: 17px;
}
.perfect_information .el-dialog .step3 .footer .nickName {
  font-size: 14px;
  color: #999;
  line-height: 34px;
  padding-left: 15px;
}
.perfect_information .el-dialog .step3 .footer .viewCount {
  flex: 1;
  text-align: right;
  line-height: 34px;
  color: #999;
}
.perfect_information .el-dialog .step3 .footer .viewCount i {
  display: inline-block;
  background: url("/static/home/images/eyes.png") no-repeat;
  background-size: contain;
  width: 20px;
  height: 12px;
  vertical-align: middle;
  margin-top: -2px;
}
.perfect_information .el-dialog .step3 .videoList li .checkedbox {
  background: url("/static/home/images/checked.png") no-repeat;
  width: 40px;
  height: 40px;
  background-size: 40px;
  position: absolute;
  bottom: 5px;
  right: 80px;
}
.perfect_information .el-dialog .step3 .videoList li .checkedbox.checked {
  background: url("/static/home/images/ischecked.png") no-repeat;
}
</style>




// WEBPACK FOOTER //
// src/pages/dialog/PerfectInformation.vue